// Footnotes popover
"use strict";
(function ($) {
    var $html = $("html"), _topMargin = $html.css("margin-top")
        ? parseInt($html.css("margin-top")) * -1
        : 0;
    var Footnotes = function (target, options) {
        var _t = this;
        this.element = $(target);
        this.options = $.extend(true, {}, Footnotes.defaults, options);
        this.notes = {};
        _prepareNotes.apply(this);
        this.popover = _createPopover(this.options.popover);
        // hide popover
        this.hide();
        //bind close events
        $(document).on("click", function (e) {
            var target = $(e.target);
            if (!target.is("[data-footnote-anchor]")) {
                _t.hide();
            }
        });
        $(window).on("scroll", function (e) {
            if (_t._scrollPosition &&
                _t.options.scrollBuffer <
                    Math.abs($(window).scrollTop() - _t._scrollPosition)) {
                _t._scrollPosition = null;
                _t.hide();
            }
        });
    };
    Footnotes.defaults = {
        noteSelector: ".footnote",
        noteIndexSelector: null,
        noteContentSelector: null,
        popover: {
            template: "<div>",
            options: null,
            styles: {
                position: "absolute",
            },
            indexTarget: null,
            contentTarget: null,
        },
        popoverPosition: null,
        scrollBuffer: 50,
        useShowClass: null,
        useHideClass: null,
        limitCharacters: null,
        whiteList: "a",
    };
    Footnotes.prototype.add = function (note) {
        var _t = this;
        if (_isNote(note)) {
            this.notes[note.index] = {
                index: note.index,
                content: note.content,
                id: note.id,
            };
            // Search for references, links with the id as the target
            $(document).on("click", '[href="#' + note.id + '"]', function (event) {
                if (!$(this).attr("data-footnote-read-more")) {
                    event.preventDefault();
                    _t.show($(this).attr("data-footnote-anchor", 1), _t.notes[note.index]);
                }
            });
        }
        return this;
    };
    Footnotes.prototype.show = function (over, note) {
        var $E = $(over);
        if (_isNote(note)) {
            var content = note.content;
            // save scroll position
            this._scrollPosition = $(window).scrollTop();
            // set index
            this.options.popover.indexTarget &&
                this.popover.find(this.options.popover.indexTarget).text(note.index);
            //set content
            if (this.options.popover.contentTarget) {
                this.popover.find(this.options.popover.contentTarget).html(content);
            }
            else {
                this.popover.html(content);
            }
            //position popover
            _positionPopover($E, this.popover);
            //show popover
            if (this.options.useShowClass) {
                this.popover
                    .addClass(this.options.useShowClass)
                    .removeClass(this.options.useHideClass);
            }
            else {
                this.popover.show();
            }
        }
        return this;
    };
    Footnotes.prototype.hide = function () {
        if (this.options.useHideClass) {
            this.popover
                .addClass(this.options.useHideClass)
                .removeClass(this.options.useShowClass);
        }
        else {
            this.popover.hide();
        }
    };
    // private functions
    function _prepareNotes() {
        var _t = this, els = this.element.find(this.options.noteSelector);
        els.each(function (i) {
            var $E = $(this), id = $E.attr("id"), index = _t.options.noteIndexSelector
                ? $E.find(_t.options.noteIndexSelector).text()
                : i, text;
            if (_t.options.noteContentSelector) {
                $E = $E.find(_t.options.noteContentSelector);
            }
            // limit characters
            text = $E.text();
            if (_t.options.limitCharacters &&
                text.length > _t.options.limitCharacters) {
                text =
                    text.slice(0, _t.options.limitCharacters) +
                        ' ... <a href="#' +
                        id +
                        '" data-footnote-read-more="1">read more</a>';
            }
            else {
                text = _stripTags($E.clone(), _t.options.whiteList);
            }
            var note = {
                index: index,
                content: text,
                id: id,
            };
            _t.add(note);
        });
        return this;
    }
    function _createPopover(popover) {
        var $E = $(popover.template, popover.options).attr("data-popover", 1);
        // apply css
        popover.styles && $E.css(popover.styles);
        // add to body
        $E.appendTo("body");
        return $E;
    }
    function _isNote(note) {
        return note && note.index && note.content && note.id;
    }
    function _positionPopover(over, popover, position) {
        var styles = {}, overPosition = over.offset(), oW = over.outerWidth(), oH = over.outerHeight(), pW = popover.outerWidth(), pH = popover.outerHeight(), classes = [
            "north-west",
            "north-centre",
            "north-east",
            "centre-west",
            "centre-centre",
            "centre-east",
            "south-west",
            "south-centre",
            "south-east",
        ];
        // find a good position if none is defined
        position || (position = _findMostArea(over));
        switch (position) {
            case "north-west":
                styles = {
                    top: overPosition.top + _topMargin + pH * -1,
                    left: overPosition.left + pW * -1,
                };
                break;
            case "north-centre":
                styles = {
                    top: overPosition.top + _topMargin + pH * -1,
                    left: overPosition.left + oW / 2 + (pW / 2) * -1,
                };
                break;
            case "north-east":
                styles = {
                    top: overPosition.top + _topMargin + pH * -1,
                    left: overPosition.left + oW,
                };
                break;
            case "centre-west":
                styles = {
                    top: overPosition.top + _topMargin + oH / 2 + (pH / 2) * -1,
                    left: overPosition.left + pW * -1,
                };
                break;
            case "centre-centre":
                styles = {
                    top: overPosition.top + _topMargin + oH / 2 + (pH / 2) * -1,
                    left: overPosition.left + oW / 2 + (pW / 2) * -1,
                };
                break;
            case "centre-east":
                styles = {
                    top: overPosition.top + _topMargin + oH / 2 + (pH / 2) * -1,
                    left: overPosition.left + oW,
                };
                break;
            case "south-west":
                styles = {
                    top: overPosition.top + _topMargin + oH,
                    left: overPosition.left + oW + pW * -1,
                };
                break;
            default:
            case "south-centre":
                styles = {
                    top: overPosition.top + _topMargin + oH,
                    left: overPosition.left + oW / 2 + (pW / 2) * -1,
                };
                break;
            case "south-east":
                styles = {
                    top: overPosition.top + _topMargin + oH,
                    left: overPosition.left + oW,
                };
                break;
        }
        popover.removeClass(classes.join(" ")).addClass(position).css(styles);
    }
    function _findMostArea(el) {
        var P = el.offset(), W = $(window), sL = W.scrollLeft(), sT = W.scrollTop(), oW = el.outerWidth(), oH = el.outerHeight(), wW = W.width(), wH = W.height(), scroll = {
            "centre-west": P.left - sL,
            "north-centre": P.top - sT,
            "centre-east": wW - oW - (P.left - sL),
            "south-centre": wH - oH - (P.top - sT),
        }, best = { position: "centre-centre", space: 0 };
        $.each(scroll, function (key, value) {
            if (value > best.space) {
                best.position = key;
                best.space = value;
            }
        });
        return best.position;
    }
    function _stripTags(element, whitelist) {
        $(element)
            .find("*")
            .not(whitelist)
            .each(function () {
            var content = $(this).contents();
            $(this).replaceWith(content);
        });
        return element.html();
    }
    // init new instance
    var fn = new Footnotes("#page-footnotes", {
        noteSelector: ".page-footnotes__note",
        noteIndexSelector: ".page-footnotes__key",
        noteContentSelector: ".page-footnotes__content",
        popover: {
            template: '<div class="c-footnote-popover"><div class="c-footnote-popover__body"/></div>',
            contentTarget: ".c-footnote-popover__body",
        },
        limitCharacters: 400,
    });
    // hide on window resize
    $(window).on("resize", function () {
        fn.hide();
    });
})(jQuery);
